import type { ReactNode } from "react"
import { Card } from "@/components/ui/Card"

// A section's bar: its name, a divider, then the controls that drive only this
// section. The bar starts the section, so each set of controls sits with what it changes.
export default function SectionHeading({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <Card className="flex flex-wrap items-center gap-x-5 gap-y-3 px-4 py-3">
      <h2 className="m-0 text-base font-semibold tracking-tight">{title}</h2>
      {children && <span className="h-6 w-px self-center bg-border" />}
      {children}
    </Card>
  )
}
